@if (!customFindbarInputArea()) {
  <div id="findbarInputContainer" class="toolbarHorizontalGroup">
    <pdf-search-input-field></pdf-search-input-field>
    <div class="toolbarHorizontalGroup">
      <pdf-find-previous></pdf-find-previous>
      <div class="splitToolbarButtonSeparator"></div>
      <pdf-find-next></pdf-find-next>
    </div>
  </div>
}

<ng-container [ngTemplateOutlet]="customFindbarInputArea() || null"> </ng-container>
